export default __webpack_public_path__ + "static/media/book-open.ea09bdb1.svg";